import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import uploadImageRequest from '../image-uploader/ImageUploader.api';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetGymRoomResponseDto } from './dto/response/get-gym-room-response.dto';
import { GetGymEventResponseDto } from './dto/response/get-gym-event-response.dto';
import { UpdateMedicalFormRequestDto } from './dto/request/update-medical-form.request.dto';
import { UpdateMedicalStatusRequestDto } from './dto/request/update-medical-status.request.dto';
import { SendMedicalDeclarationRequestDto } from './dto/request/send-medical-declaration.request.dto';
import { SendMedicalDeclarationResponseDto } from './dto/response/send-medical-declaration.response.dto';

const USERS_PATH = HttpPathsEnum.USERS;
const EVENTS_PATH = HttpPathsEnum.EVENTS;
const RESOURCE_PATH = HttpPathsEnum.RESOURCE;

class GymApi {
  public async getFitnessEvents(id?: number, locationId?: number) {
    const request: HttpRequest = {
      url: `${EVENTS_PATH}/event/all-fitness?user_id=${id}&scope=${locationId}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetGymEventResponseDto[]>(
      request,
      GetGymEventResponseDto
    );
  }

  public async getAllGyms() {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/get-all-gyms`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetGymRoomResponseDto[]>(
      request,
      GetGymRoomResponseDto
    );
  }

  public async getGymInMyResource(locationId: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/gym-by-location-id/${locationId}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetGymRoomResponseDto>(
      request,
      GetGymRoomResponseDto
    );
  }

  public async sendMedicalDeclaration(data: SendMedicalDeclarationRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/medical-form`,
      method: RequestType.POST,
      data,
    };

    return await AppHttpClient.exec<
      SendMedicalDeclarationRequestDto,
      SendMedicalDeclarationResponseDto
    >(request, SendMedicalDeclarationResponseDto);
  }

  public async uploadMedicalCertificate(data: any) {
    return await uploadImageRequest(
      `${USERS_PATH}/medical-form/upload-certificate`,
      data
    );
  }

  public async updateMedicalForm(data: UpdateMedicalFormRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/medical-form/update-medical-form`,
      method: RequestType.PATCH,
      data,
    };

    return await AppHttpClient.exec<any, UpdateMedicalFormRequestDto>(
      request,
      SendMedicalDeclarationResponseDto
    );
  }

  public async updateMedicalStatus(data: UpdateMedicalStatusRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/medical-form/update-medical-status`,
      method: RequestType.PATCH,
      data,
    };

    return await AppHttpClient.exec<any, UpdateMedicalStatusRequestDto>(
      request,
      SendMedicalDeclarationResponseDto
    );
  }
}

export default new GymApi();
